<template>
	<!-- BEGIN: Left Aside -->
	<div id="m_aside_left" class="m-grid__item m-aside-left ">
		<!-- BEGIN: Aside Menu -->
		<div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-light m-aside-menu--submenu-skin-light" data-menu-vertical="true" m-menu-scrollable="0" m-menu-dropdown-timeout="500">
			<ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
				<router-link :event="item.resource==''?'disabled':'click'" tag="li" :to="getMenuLink(item)" v-for="item in menuItems" class="m-menu__item m-menu__item--submenu router-link-active m-menu__item--open" aria-haspopup="true" m-menu-submenu-toggle="hover">
					<a :href="getMenuLink(item)" class="m-menu__link m-menu__toggle">
						<i v-if="item.icon !== ''" :class="'m-menu__link-bullet ' + item.icon"><span></span></i>
						<span class="m-menu__link-text">{{getMenuAlias(item)}}</span>
						<i v-if="item.childs.length != 0" class="m-menu__ver-arrow la la-angle-right"></i>
					</a>
					<div class="m-menu__submenu" v-if="item.childs.length != 0">
						<ul v-if="item.childs.length > 0" class="m-menu__subnav">
							<router-link tag="li" :to="getMenuLink(child)" v-for="child in item.childs" class="m-menu__item"  active-class="m-menu__item--active">
								<a :href="getMenuLink(child)" class="m-menu__link">
									<i v-if="child.icon !== ''" :class="'m-menu__link-bullet ' + child.icon"></i>
									<span class="m-menu__link-text">{{getMenuAlias(child)}}</span>
								</a>
							</router-link>
						</ul>
					</div>
				</router-link>
			</ul>
		</div>
		<!-- END: Aside Menu -->
	</div>
	<!-- END: Left Aside -->
</template>
<script>
    export default {
		data(){
	        return {
	            "menuItems": "",
	            "isShowSub": false,
	        }
	    },

	    mounted(){
	    	this.showChild();
	    },

	    created () {
	        this.getMenu();
	    },

	    methods: {
	        getMenu: async function(){
	            let menuObj = await window.axios.get("/admin-panel/menu");
	            menuObj = menuObj.data;

	            let parents = menuObj.data.filter((e)=>{ return e.parent_id == 0; });
	            this.menuItems = parents.map((e) => {
	            	let childs = menuObj.data.filter((c)=>{ return e.id == c.parent_id; });
	            	e.childs = childs;
	            	return e;
	            });
	            if(this.menuItems.length != 0) this.isShowSub = true;
	        },

	        getMenuLink: function(menuItem){
	    		let url = menuItem.resource !== "" ? "/" + menuItem.resource : "javascript:;";
	    		if(typeof  menuItem.childs != "undefined" && menuItem.childs.length != 0) return "";
	    		return url;
	    	},

	    	getMenuAlias: function(menuItem){
	    		let alias = menuItem.alias ? menuItem.alias : "";
	    		return alias;
	    	},

	    	showChild: function(){
	    		$(".m-menu__item").hover(
					function() {
						$(this).find(".m-menu__submenu").show();
					}, function() {
						$(this).find(".m-menu__submenu").hide();
					}
				);
	    	}
	    }
	}
</script>
<style>
	.m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__heading .m-menu__link-bullet, 
	.m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__link .m-menu__link-bullet,
	.m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__heading .m-menu__link-bullet,
	.m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link .m-menu__link-bullet{
		width: 30px;
		font-size: 20px;
	    color: #868aa8;
	}
	.m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link{
		padding: 9px 0px;
	}
	.m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__submenu .m-menu__subnav>.m-menu__item>.m-menu__link{
		padding: 0px 30px;
	}
	.m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__heading .m-menu__link-text, 
	.m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link .m-menu__link-text{
		font-size: 1.32rem;
	}
	.m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__heading .m-menu__link-text,
	.m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__link .m-menu__link-text{
		font-size: 1.1rem;
	}
    .m-aside-menu.m-aside-menu--skin-light .m-menu__nav>.m-menu__item.m-menu__item--open>.m-menu__heading .m-menu__link-text, 
    .m-aside-menu.m-aside-menu--skin-light .m-menu__nav>.m-menu__item.m-menu__item--open>.m-menu__link .m-menu__link-text{
    	color: #868aa8;
    }
    @media (max-width: 1024px){
    	#m_aside_left_offcanvas_toggle{
    		float: left;
    		margin-top: 18px;
    	}
    	.m-stack.m-stack--general.m-stack--ver>.m-stack__item.m-brand__logo{
    		display: none;
    	}
        .m-header .m-header__bottom{
            height: 0px;
        }
        .m-body .m-grid__item.m-grid__item--fluid.m-wrapper{
            margin-top: 70px;
            padding: 10px 0px 35px 0px;
        }
        .m-dropdown.m-dropdown--mobile-full-width.m-dropdown--align-center>.m-dropdown__wrapper, 
        .m-dropdown.m-dropdown--mobile-full-width>.m-dropdown__wrapper{
            width: 260px;
            margin: 0 auto;
            left: auto;
            right: 5px;
        }
        .m-nav.m-nav--inline>.m-nav__item>.m-nav__link{
            padding: 15px 0px;
        }

        .m-aside-left{
            width: 70% !important;
            left: -70%;
        }
        .m-aside-menu .m-menu__nav{
            padding: 12px;
        }
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link{
        	padding: 0px;
        }
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__heading .m-menu__link-text, 
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link .m-menu__link-text{
            font-size: 3.3rem;
        }
        .m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__heading .m-menu__link-text, 
        .m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__link .m-menu__link-text{
            font-size: 2.5rem;
        }
        .m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__heading .m-menu__link-bullet, 
        .m-aside-menu .m-menu__nav>.m-menu__item .m-menu__submenu .m-menu__item>.m-menu__link .m-menu__link-bullet, 
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__heading .m-menu__link-bullet, 
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link .m-menu__link-bullet{
			width: 45px;
		    font-size: 35px;
        }
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__heading .m-menu__ver-arrow, 
        .m-aside-menu .m-menu__nav>.m-menu__item>.m-menu__link .m-menu__ver-arrow{
			width: 40px;
		    font-size: 2.5rem;
        }
        .m-aside-menu .m-menu__nav .m-menu__item{
            padding: 5px 0px;
        }
    }
</style>